import { render, staticRenderFns } from "./SellerEstateAgent.vue?vue&type=template&id=531fffbe&scoped=true&"
import script from "./SellerEstateAgent.vue?vue&type=script&lang=js&"
export * from "./SellerEstateAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531fffbe",
  null
  
)

export default component.exports